import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';
import { OrderResponseEntity } from 'src/entities/Order.response.entity';
import { OrderAssignment } from 'src/entities/orderEntity';

import { queryKey } from './useOrders.request';

export const useMutationOrderAssignment = () => {
  const queryClient = useQueryClient();

  return {
    update: useMutation({
      mutationFn: (data: OrderAssignment) => axios.put(`/api/v2/orders/${data.order_id}/order_assignment`, { data }),

      onSuccess: (res: AxiosResponse<OrderAssignment>, variables) => {
        const queries = queryClient.getQueryCache().findAll({ predicate: (query) => query.queryKey.includes(queryKey) });
        queries.forEach((query) => {
          queryClient.setQueryData(query.queryKey, (oldData: HavePaginationEntity<OrderResponseEntity>) => {
            if (oldData && oldData.data) {
              return {
                ...oldData,
                data: oldData.data.map((it) => (it.id === variables.order_id ? it.order_assignments_json = JSON.stringify(res.data || {}) : it)),
              };
            }
            return oldData;
          });
        });

        void queryClient.invalidateQueries({
          queryKey: ['dashboards']
        });
        void queryClient.invalidateQueries({
          queryKey: ['orders']
        });
        void queryClient.invalidateQueries({
          queryKey: ['useQueryPlanningsDeliveries']
        });
        void queryClient.resetQueries({
          queryKey: [queryKey]
        });
      }
    }),
  };
};
